import Privacy from '@wetransfer/transfer/modules/privacy';
import TermsAndConditions from '@wetransfer/transfer/modules/terms-and-conditions';

export const getSession = () => {
  const sideloaded = window['__session__'] || {
    user: {},
  };

  return {
    language: sideloaded.user.language, // what language
    tandc: TermsAndConditions.areAccepted(), // accepted T&C or not
    // Does the user allow tracking after clicking the banner
    privacy: {
      notified: Privacy.userHasClosedBanner(),
      allowTracking: Privacy.userAllowsTracking(),
    },
    plus: sideloaded.user.id || false, // is logged in or not
    domain: null,
    incompatible_version: false,
    region: {
      country: null, // what country is this client (ip)
      continent: null, // what continent is this client (ip)
      currency: null, //currency base on user country
    },
    domainUserId: null,
    transferExpiryOptions: [],
    assetUpload: {
      maxWallpaperSize: 5 * 1024 * 1024, // 5MB
      maxProfilePictureSize: 5 * 1024 * 1024, // 5MB
      maxEmailBackgroundSize: 3 * 1024 * 1024, // 3 MB
    },
    wallpaper: null,
  };
};

export default getSession();
